import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import Input from "./common/input";
import AuthLayout from "./common/layout";
import { callAuthAPi } from "../utils/mainapp-api";
export default function LoginCopy() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = async () => {
    if (!email) {
      await window.swal.fire({
        icon: "error",
        title: "Email is required",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }
    setLoading(true);
    const dataToPost = {
      email: email,
    };
    const response = await callAuthAPi("post", "user-login", dataToPost, false);
    console.log("rr", response);
    if (!response) {
      setLoading(false);
      return;
    }
    if (response.message == "ADMINLOGIN") {
      const willDelete = await window.swal.fire({
        icon: "info",
        title: "Admin Login Detected",
        html: "Looks like you are an admin trying to sign in.<br /> Click below to navigate to admin sign in page",
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      setLoading(false);
      window.location.href = "https://kycaml.systems/admin-login";
      return;
    } else {
      if (response.success) {
        localStorage.setItem("email", email);
        navigate("/otp-verification", {
          state: {
            title: "OTP Verification",
            subtitle: "Please enter the OTP code below:",
            email,
          },
        });
      } else {
        await window.swal.fire({
          icon: "error",
          title: "Invalid Email Address",
          html: "Email Address is not valid, please check the email address and try again",
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }
    }
    setLoading(false);
  };
  return (
    <AuthLayout
      headTitle="Sign in - Ahrvo"
      title="Login"
      subtitle="Login to your account"
      form={
        <form>
          <Input
            placeholder={"Enter your email address or username"}
            label={"Email"}
            value={email}
            setValue={setEmail}
          />

          <div className="form-group">
            <button
              onClick={handleClick}
              type="button"
              style={{ width: "100%" }}
              className="btn btn-lg btn-primary btn-block"
            >
              {loading ? <Spinner color="white"></Spinner> : "Login"}
            </button>
          </div>
        </form>
      }
    />
  );
}
